import { common } from "@mui/material/colors"

export default {
  components: {
    MuiButton: {
      color: "inherit",
    },
    MuiButtonBase: {
      disableRipple: true,
    },
    MuiTab: {
      sx: {
        minWidth: 160,
      },
    },
  },
  palette: {
    primary: {
      main: "#03a9f4",
      contrastText: common.white,
    },
    secondary: {
      main: "#607d8b",
    },
  },
  typography: {
    fontSize: 16,
    fontFamily: ['"Open Sans"', '"Helvetica"', '"Arial"', "sans-serif"].join(","),
    fontWeightMedium: 600,
    useNextVariants: true,
    body1: {
      fontFamily: ['"Open Sans"', '"Helvetica"', '"Arial"', "sans-serif"].join(","),
    },
  },
}
